module.exports = __webpack_public_path__ + "img/logo.93bd2e88.png";